module.exports = __webpack_public_path__ + "static/media/loader.b3a51e11.svg";